/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project = feature.project;

    const printLinks = project.getNodeLinks(feature, 'digital_line_set');
    const newline = '+ "\\r\\n"';
    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `#****${doneLinks[0].getSourceId()}****#` : '';
    for (let i = 0; i < printLinks.length; i += 1) {
        const link = printLinks[i];
        const source = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
        const lineNumber = project.parseCodeExpression(feature.getSettingValue('LINE_NUMBER'), sourceParams, TibboDataType.STRING);
        const value = project.parseCodeExpression(feature.getSettingValue('VALUE'), sourceParams, TibboDataType.STRING);

        const peripherals = Peripherals.getPin(lineNumber, feature.project.device.id)?.peripherals;
        let peripheralPort = '0';
        let gpioNum: string | undefined = '0';
        if (peripherals) {
            peripheralPort = peripherals.filter(p => p.peripheralType === 'gpio')[0].peripheralPort;
            gpioNum = peripherals.filter(p => p.peripheralType === 'gpio')[0].num;
        }

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
const struct gpio_dt_spec pin${feature.getID()} = GPIO_DT_SPEC_GET_BY_IDX(DT_NODELABEL(${peripheralPort}), gpios, ${gpioNum});
gpio_pin_set_dt(&pin${feature.getID()}, ${value});
${doneBlock}`,
        });
    }

    return blocks;
};
